<template>
    <div>
        <div class="row">
            <div class="col-sm-12 col-md-12">
                <Card>
                    <div class="row mb-4">
                        <h5 class="col-sm-12 col-md-10 text-bold">{{ __('Load') }}</h5>

                        <div class="col-sm-12 col-md-12">&nbsp;</div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">
                                    <dt>{{ __('Date of receipt') }}:</dt>
                                    <dd>{{ release.receiptDate }}</dd>
                                </div>
                            </div>
                        </div>

                        <div class="hidden-sm col-md-2"></div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">
                                    <dt>{{ __('Status') }}:</dt>
                                    <dd>{{ release.status }}</dd>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-12">&nbsp;</div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">
                                    <dt>{{ __('Invoice No') }}:</dt>
                                    <dd>{{ release.invoiceNo }}</dd>
                                </div>
                            </div>
                        </div>

                        <div class="hidden-sm col-md-2"></div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">
                                    <dt>{{ __('Payment start date') }}:</dt>
                                    <dd>{{ release.paymentStartDate }}</dd>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-12">&nbsp;</div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">
                                    <dt>{{ __('Sender') }}:</dt>
                                    <dd>{{ release.sender }}</dd>
                                </div>
                            </div>
                        </div>

                        <div class="hidden-sm col-md-2"></div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">
                                    <dt>{{ __('New payer') }}:</dt>
                                    <dd>{{ release.newPayer }}</dd>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-12">&nbsp;</div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">
                                    <dt>{{ __('Recipient') }}:</dt>
                                    <dd>{{ release.recipient }}</dd>
                                </div>
                            </div>
                        </div>

                        <div class="hidden-sm col-md-2"></div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">
                                    <dt>{{ __('New recipient') }}:</dt>
                                    <dd>{{ release.newRecipient }}</dd>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ShipmentsOverview :shipments="release.shipments"/>

                </Card>
                <br/>
                <div class="row">
                    <div class="col-12 text-right">
                        <button
                            @click="$router.push('/releases')"
                            class="btn btn-sm btn-info col-sm-6 col-md-4"
                        >
                            {{ __('Back') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { $api } from '../../services/api'
import ShipmentsOverview from '../Releases/ShipmentsOverview'

export default {
  name: 'LoadView',

  components: { ShipmentsOverview },

  beforeRouteEnter (to, from, next) {
    $api.releases.show(to.params.id).then((release) => {
      next((vm) => {
        vm.setRelease(release)
      })
    })
  },

  computed: {
    ...mapGetters('ReleasesModule', [
      'release'
    ])
  },

  methods: {
    ...mapMutations('ReleasesModule', [
      'setRelease',
      'addReleaseShipment'
    ])
  }
}
</script>
